import { createBrowserRouter, Navigate } from "react-router-dom";
import { SignIn } from "@/features/auth/SignIn";
import { AppShell } from "@/components/layout/AppShell";

// Single-page app: root goes straight to the workspace (which redirects to
// /signin when not authenticated). No separate marketing landing.
export const router = createBrowserRouter([
  { path: "/", element: <Navigate to="/app/learn" replace /> },
  { path: "/signin", element: <SignIn /> },
  { path: "/app/learn", element: <AppShell /> },
  { path: "/app", element: <Navigate to="/app/learn" replace /> },
  { path: "/app/*", element: <Navigate to="/app/learn" replace /> },
  { path: "*", element: <Navigate to="/app/learn" replace /> },
]);
